"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadElements = void 0;

var _script = require("./script");

let elementsPromise;

const loadElements = () => {
  if (!elementsPromise) {
    elementsPromise = new Promise((resolve, reject) => {
      if (typeof window !== 'object') {
        reject(new Error('Tried to load BasisTheoryElements in a non-DOM environment.'));
        return;
      }

      if (window.BasisTheoryElements) {
        resolve(window.BasisTheoryElements);
        return;
      }

      try {
        const url = `https://${"js.basistheory.com"}/elements`;
        let script = (0, _script.findScript)(url);

        if (!script) {
          script = (0, _script.injectScript)(url);
        }

        script.addEventListener('load', () => {
          if (window.BasisTheoryElements) {
            resolve(window.BasisTheoryElements);
          } else {
            reject(new Error('BasisTheoryElements did not load properly.'));
          }
        });
        script.addEventListener('error', event => {
          reject((event === null || event === void 0 ? void 0 : event.error) || new Error('There was an unknown error when loading BasisTheoryElements'));
        });
      } catch (error) {
        reject(error);
        return;
      }
    });
  }

  return elementsPromise;
};

exports.loadElements = loadElements;